module.exports = __webpack_public_path__ + "static/the-california-endownment-eaefc69a09bb9b0f277e17a726a8e1b0.png";